(function () {
    'use strict';

    angular.module('app.helpText', [
        'app.core',
        'app.widgets'
    ]);
})();
